import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import { AlertTriangle, Printer } from 'lucide-react';
import { Botao } from '@/componentes/ui/botao';

/**
 * Um PDF A4 do próprio WMS (o DANFE) aberto no EDGE, com prévia e escolha de
 * impressora — ver `abrirPdfNoEdge`.
 *
 * Fora do login e do AppShell, como o `/romaneio-a4`: o Edge não tem a
 * sessão. `u` é o endereço do PDF na API, já com o token curto que o autoriza.
 * Só aceita caminho da própria API: esta página não abre endereço de fora.
 */
export function PdfA4(): JSX.Element {
  const [busca] = useSearchParams();
  const endereco = busca.get('u') ?? '';
  const valido = endereco.startsWith('/api/') && !endereco.includes('//');
  const quadro = React.useRef<HTMLIFrameElement>(null);
  const jaAbriu = React.useRef(false);
  const [carregado, definirCarregado] = React.useState(false);

  const imprimir = React.useCallback((): void => {
    const janela = quadro.current?.contentWindow;
    if (!janela) return;
    janela.focus();
    janela.print();
  }, []);

  // Abre o diálogo sozinho uma vez; o visualizador de PDF precisa de um
  // instante depois do `load` para ter as páginas desenhadas.
  React.useEffect(() => {
    if (!carregado || jaAbriu.current) return;
    jaAbriu.current = true;
    window.setTimeout(imprimir, 600);
  }, [carregado, imprimir]);

  return (
    <div className="flex h-screen flex-col gap-3 bg-superficie2 p-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-[18px] font-bold leading-tight">DANFE</h1>
        <Botao variante="primaria" onClick={imprimir} disabled={!carregado}>
          <Printer className="h-4 w-4" />
          Imprimir
        </Botao>
      </div>
      {valido ? (
        <iframe
          ref={quadro}
          src={endereco}
          title="DANFE"
          onLoad={() => definirCarregado(true)}
          className="cartao min-h-0 w-full flex-1 bg-white"
        />
      ) : (
        <p className="flex items-start gap-2 rounded-lg bg-status-divergenciaFundo px-3 py-2 text-[13px] text-status-divergencia">
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
          Link inválido. Volte ao WMS e clique em Imprimir de novo.
        </p>
      )}
    </div>
  );
}
